import gql from "graphql-tag"

const ASSIGN_ROLES_QUERY = gql`
  query assignRolesQuery {
    assignRoles
  }
`

export default ASSIGN_ROLES_QUERY
